<template>
  <div id="app" class="ScrollingDiv" v-on:scroll="scrollControl($event)" v-if="okanMain != undefined">

    <page
      v-bind:okanMain="okanMain"
      v-bind:pageData="okanMain.getElements(okanMain.pages[okanMain.currentPage])"
    />

    <popup
      v-bind:okanMain="okanMain"
      v-if="okanMain.popup!=null"
    />


  </div>
</template>

<script>

import okanMain from './js/okanMain.js';
import page from './components/page.vue';
import popup from './components/popup.vue';


export default {
  name: 'App',
  components: {
    page,
    popup,
    
  },
	data: function() {
			return {
        okanMain: new okanMain(this),
			}
  },
  created(){
    window.addEventListener("resize", this.okanMain.resize);
  },
  destroyed(){
    window.removeEventListener("resize", this.okanMain.resize);
  },
  mounted(){
    this.okanMain.init();
  },
  methods: {
    scrollControl(event){
      event.stopPropagation();
    }
  }
}
</script>
<style src='../public/css/style.css'></style>


